import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

/** Duración por defecto (ms). `0` o `null` = no auto-cierra. */
export const TOAST_DEFAULT_DURATION = 4000;

/** Tipos soportados: success | error | warning | info */
export const TOAST_VARIANTS = {
  success: {
    accent: '#3A7877',
    iconBg: '#489291',
    iconColor: '#E8F4F4',
    Icon: CheckCircleOutlineIcon,
  },
  error: {
    accent: '#F87171',
    iconBg: '#F87171',
    iconColor: '#fff',
    Icon: ErrorOutlineIcon,
  },
  warning: {
    accent: '#FBBF24',
    iconBg: '#FBBF24',
    iconColor: '#fff',
    Icon: WarningAmberIcon,
  },
  info: {
    accent: '#125DDB',
    iconBg: '#0C4BB5',
    iconColor: '#fff',
    Icon: ErrorOutlineIcon,
  },
};

export const TOAST_BG = '#1C1C1C';
export const TOAST_TEXT = '#FFFFFF';
export const TOAST_CLOSE = 'rgba(255,255,255,0.85)';
